import { type ReactNode, useContext, useEffect } from 'react';

import { useLocation } from '@remix-run/react';
import type { TNavbarMenuBurgerElement } from '@shared/dream-components';
import { NavbarMenuBurgerV2 as NavbarMenuBurgerElement } from '@shared/dream-components';

import { NavbarBurgerContext } from './NavbarMenuBurger.context';

interface Props {
  node: TNavbarMenuBurgerElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuBurger = ({ node, children, screen }: Props) => {
  const { isOpen, setIsOpen, isFixed } = useContext(NavbarBurgerContext);
  const location = useLocation();

  // Close menu on route change
  useEffect(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  }, [location]);

  return (
    <NavbarMenuBurgerElement
      element={node}
      screen={screen}
      onClick={() => setIsOpen(!isOpen)}
      attributes={{ 'data-is-open': isOpen }}
      controlbyselected="false"
      isFixed={isFixed}
    >
      {children}
    </NavbarMenuBurgerElement>
  );
};

export default NavbarMenuBurger;
